import { Component, input, OnInit } from '@angular/core';

@Component({
  selector: 'avs-li-main-logo',
  templateUrl: './main-logo.component.html',
})
export class MainLogoComponent implements OnInit {
  isMobile = input(false);
  smallVersion = input(false);
  logoWidth = 185;
  logoHeight = 54;
  viewBox = `0,0 ${this.logoWidth} ${this.logoHeight}`;

  ngOnInit() {
    this.logoWidth = this.smallVersion() ? 185 : this.isMobile() ? 300 : 350;
    this.logoHeight = this.smallVersion() ? 30 : this.isMobile() ? 40 : 54;
    this.viewBox = `0,0 ${this.logoWidth} ${this.logoHeight}`;
  }
}
